<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<cas-project-tab
  [project]="project"
  [projectUI]="projectUI"
  (closeTab)="closeTab.emit($event)"
  (tabChanged)="tabChanged.emit($event)"
>
</cas-project-tab>
